import { render, staticRenderFns } from "./ScMain.vue?vue&type=template&id=24701c3c"
import script from "./ScMain.vue?vue&type=script&lang=js"
export * from "./ScMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports